import { z } from 'zod/v4';
import type { TracingEvent } from '../../core/use-cases/types.js';

export const SEND_TO_TRACING_MAX_LINES = 100;

export const SendOrderToTracingInputSchema = z.object({
  orderLineIds: z
    .array(z.string().min(1))
    .min(1)
    .max(SEND_TO_TRACING_MAX_LINES)
    .optional(),
  notifySupplier: z.boolean().default(true),
  attachmentTemplateId: z.string().min(1).optional(),
});

export type SendOrderToTracingInput = z.infer<
  typeof SendOrderToTracingInputSchema
>;

export const SendOrderToTracingLineResultSchema = z.object({
  orderLineId: z.string(),
  orderLineNumber: z.string(),
  tracingOrderId: z.string(),
  tracingReflectionOrderId: z.string(),
  tracingOrderRequestedAt: z.string(),
});

export type SendOrderToTracingLineResult = z.infer<
  typeof SendOrderToTracingLineResultSchema
>;

export const SendOrderToTracingSkippedLineSchema = z.object({
  orderLineId: z.string(),
  orderLineNumber: z.string().nullable(),
  reasons: z.array(z.string()),
});

export type SendOrderToTracingSkippedLine = z.infer<
  typeof SendOrderToTracingSkippedLineSchema
>;

export const SendOrderToTracingResponseSchema = z.object({
  orderId: z.string(),
  results: z.array(SendOrderToTracingLineResultSchema),
  skippedLines: z.array(SendOrderToTracingSkippedLineSchema),
});

export type SendOrderToTracingResponse = z.infer<
  typeof SendOrderToTracingResponseSchema
>;

export type SendOrderToTracingResult = SendOrderToTracingResponse & {
  tracingEvents: TracingEvent[];
};
